import script from "./Wind_Snow.vue?vue&type=script&setup=true&lang=js"
export * from "./Wind_Snow.vue?vue&type=script&setup=true&lang=js"

import "./Wind_Snow.vue?vue&type=style&index=0&id=7886b0f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7886b0f6"]])

export default __exports__